module.exports = __webpack_public_path__ + "static/img/1494_phase_function_Paper_PointsHejduk_Prediction.87330f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1494_phase_function_Paper_PointsHejduk_Prediction.png
// module id = XgPQ
// module chunks = 0